import BaseRequest from './index'

class BankService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.getAllBanks = this.getAllBanks.bind(this)
    this.getMyBanks = this.getMyBanks.bind(this)
    this.resolveBankAccount = this.resolveBankAccount.bind(this)
    this.createBankAccount = this.createBankAccount.bind(this)
    this.deleteBankAccount = this.deleteBankAccount.bind(this)
  }

  async getAllBanks<T>(): Promise<T> {
    return await this.api.get('/banks')
  }

  async getMyBanks<T>(): Promise<T> {
    return await this.api.get('/user/bank')
  }

  async resolveBankAccount<T>(data: any): Promise<T> {
    return await this.api.post('/user/bank/resolve', data)
  }

  async createBankAccount<T>(data: any): Promise<T> {
    return await this.api.post('/user/bank/create', data)
  }

  async deleteBankAccount(data: { id: string }) {
    return await this.api.delete(`/user/bank/${data.id}/delete`)
  }
}

const bankService = new BankService()

export default bankService
